import styles from './style.module.css'
import { useCallback } from 'react'
import { useTranslation } from 'next-i18next'
import { SPEEDS_LIST } from '@constants/definition'
import { FootIcon2, BusIcon2, TramIcon, MetroIcon } from '@/components/ui/icons'
import FootIcon2White from '@/components/ui/icons/icons/FootIcon2White'

const StationDistance = ({ data, invertColor = false }) => {
  const { t } = useTranslation(['developers'])
  return (
    <div className={styles.stationDistance}>
      {data.slice(0, 2).map((station) => (
        <Item key={station.id} item={station} invertColor={invertColor} />
      ))}
    </div>
  )
}

const Item = ({ item, invertColor }) => {
  const { t } = useTranslation(['developers'])
  const Logo = () => {
    if (item.transportType === 'metro') {
      return <MetroIcon />
    }
    if (item.transportType === 'bus') {
      return <BusIcon2 />
    }
    return <TramIcon />
  }

  const countSpeed = useCallback((item, speed) => {
    let count = Math.ceil((item.distance / 1000 / speed) * 60)
    return count
  }, [])

  return (
    <div className={`${styles.item} ${invertColor && styles.invertColor}`}>
      <div className={styles.name}>
        <Logo />
        <span className={styles.name}>{item.name}</span>
      </div>
      <span className={styles.distance}>
        {invertColor ? <FootIcon2White /> : <FootIcon2 />}
        {t('developers::developerObjects::stationTime', {
          min: countSpeed(item, SPEEDS_LIST.FOOT),
        })}
      </span>
    </div>
  )
}

export default StationDistance
